import httpClient from './httpClient';

export const CUSTOMER_ENDPOINT = '/backoffice/customers';
export const getCustomerAPI = (id, params) => httpClient.get(`${CUSTOMER_ENDPOINT}/${id}`, { params });
export const getCustomerListAPI = (params) => httpClient.get(CUSTOMER_ENDPOINT, { params });
export const createCustomerAPI = (params = {}) => httpClient.post(CUSTOMER_ENDPOINT, params);
export const updateCustomerAPI = (id, params = {}) => httpClient.put(`${CUSTOMER_ENDPOINT}/${id}`, params);
export const resendVerificationLinkAPI = (id) => httpClient.post(`${CUSTOMER_ENDPOINT}/${id}/resend`);
export const postCustomerExport = (params = {}) => httpClient.post(`${CUSTOMER_ENDPOINT}/reports/export`, params);
